/* KK cart enhancements (drawer + cart page). Loaded on every page by sections/kk-site-style.liquid.
   - Countdown timer ("cart reserved for 09:59"), restarts when it runs out (per browser session).
   - Free-gift progress bar ("Buy worth ₹1,000 and get a gold-plated ring").
   - "You save" row when a discount applies.
   - "Add more" suggestions from a chosen collection, one-tap add.
   - Trust icons under the checkout button.
   - Tidy product titles ("GOLD PLATED KADA....🔥✅" → "Gold Plated Kada"). Title links hold plain text only.
   Horizon re-renders the cart on every update, so everything is re-applied after each change.
   Nothing here touches the checkout / Fastrr BUY NOW button itself. */

const cfgEl = document.querySelector('[data-kk-cart-cfg]');
const cfg = cfgEl ? { ...cfgEl.dataset } : {};
const root = window.Shopify?.routes?.root || '/';
const threshold = Math.max(0, Number(cfg.threshold || 0)) * 100; // paise
let cart = null;
let upsell = null; // cached products from the upsell collection

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const money = (paise) => {
  const n = Math.round(paise) / 100;
  const amount = new Intl.NumberFormat('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
  return (cfg.moneyFormat || '₹{{amount}}').replace(/\{\{\s*[\w_]+\s*\}\}/, amount);
};
const tidy = (t) => t.replace(/🔥|✅/g, '').replace(/\.{3,}/g, '').trim().toLowerCase()
  .split(/\s+/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
const img = (src, w) => (src ? `${src.startsWith('//') ? 'https:' + src : src}${src.includes('?') ? '&' : '?'}width=${w}` : '');

async function loadCart() {
  try { cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch { /* keep last */ }
  render();
}

/* ---------- timer ---------- */
const TIMER_KEY = 'kk-cart-timer-end';
function timerEnd() {
  const secs = Math.max(30, Number(cfg.timerSecs || 0) || Number(cfg.timerMinutes || 10) * 60);
  let end = 0;
  try { end = Number(sessionStorage.getItem(TIMER_KEY) || 0); } catch { /* ignore */ }
  if (!end || end < Date.now()) {
    end = Date.now() + secs * 1000;
    try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch { /* ignore */ }
  }
  return end;
}
function timerText() {
  const left = Math.max(0, timerEnd() - Date.now());
  const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
setInterval(() => {
  const t = timerText();
  document.querySelectorAll('[data-kk-timer-clock]').forEach((el) => { el.textContent = t; });
}, 1000);

/* ---------- pieces ---------- */
function timerHTML() {
  return `<div class="kk-timer" data-kk-timer role="status">
    <span class="kk-timer__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9.5 2.5h5"/></svg></span>
    <p>${cfg.timerText || 'Your cart is reserved for'}</p>
    <strong data-kk-timer-clock>${timerText()}</strong>
  </div>`;
}

function offerHTML(subtotal) {
  const left = threshold - subtotal;
  const pct = threshold ? Math.min(100, Math.round((subtotal / threshold) * 100)) : 0;
  const done = left <= 0;
  const text = done ? cfg.done : (cfg.msg || '').replace('[amount]', `<strong>${money(left)}</strong>`);
  return `<div class="kk-offer${done ? ' is-done' : ''}" data-kk-offer role="status">
    <div class="kk-offer__row">
      <span class="kk-offer__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="14" r="6.5"/><path d="M9 4.5h6l-1.6 3.4h-2.8z"/><path d="M10.4 7.9 9 4.5M13.6 7.9 15 4.5"/></svg></span>
      <p>${text}</p>
    </div>
    <div class="kk-offer__bar" aria-hidden="true"><i style="width:${pct}%"></i></div>
  </div>`;
}

function upsellHTML() {
  if (!upsell || !cart) return '';
  const inCart = new Set(cart.items.map((i) => i.product_id));
  const picks = upsell.filter((p) => !inCart.has(p.id) && p.variants.some((v) => v.available) && Number(p.variants[0].price) >= 50 && !/partial-payment/.test(p.handle)).slice(0, 3);
  if (!picks.length) return '';
  return `<div class="kk-upsell" data-kk-upsell>
    <p class="kk-upsell__title">${esc(cfg.upsellHeading || 'Add more, save more')}</p>
    <ul class="kk-upsell__list">${picks.map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const single = p.variants.length === 1;
      const pic = p.images?.[0]?.src;
      return `<li class="kk-upsell__item">
        <a class="kk-upsell__img" href="${root}products/${esc(p.handle)}">${pic ? `<img src="${img(pic, 160)}" alt="" loading="lazy">` : ''}</a>
        <div class="kk-upsell__info"><a href="${root}products/${esc(p.handle)}">${esc(tidy(p.title))}</a><span>${money(Math.round(Number(v.price) * 100))}</span></div>
        ${single
          ? `<button type="button" class="kk-upsell__add" data-kk-upsell-add="${v.id}">+ Add</button>`
          : `<a class="kk-upsell__add" href="${root}products/${esc(p.handle)}">Choose</a>`}
      </li>`;
    }).join('')}</ul>
  </div>`;
}

function trustHTML() {
  const items = (cfg.trust || '').split(',').map((s) => s.trim()).filter(Boolean);
  if (!items.length) return '';
  const icons = [
    '<svg viewBox="0 0 24 24"><rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/></svg>',
    '<svg viewBox="0 0 24 24"><path d="M12 3l7.5 3v5.5c0 4.5-3.2 8-7.5 9.5-4.3-1.5-7.5-5-7.5-9.5V6z"/><path d="M8.8 12l2.2 2.2 4.4-4.4"/></svg>',
    '<svg viewBox="0 0 24 24"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>',
  ];
  return `<ul class="kk-cart-trust" data-kk-cart-trust>${items.slice(0, 3).map((t, i) => `<li>${icons[i % 3]}<span>${esc(t)}</span></li>`).join('')}</ul>`;
}

function place(comp, attr, html, where) {
  const old = comp.querySelector(`[${attr}]`);
  if (!html) { old?.remove(); return; }
  if (old && old.dataset.kkSig === html.length + ':' + html.slice(-60)) return;
  old?.remove();
  where(html);
  const el = comp.querySelector(`[${attr}]`);
  if (el) el.dataset.kkSig = html.length + ':' + html.slice(-60);
}

function render() {
  document.querySelectorAll('cart-items-component').forEach((comp) => {
    comp.querySelectorAll('.cart-items__title').forEach((a) => {
      if (a.children.length || a.dataset.kkTidy === a.textContent) return;
      const t = tidy(a.textContent);
      a.textContent = t;
      a.dataset.kkTidy = t;
    });
    if (!cart) return;
    const has = cart.item_count > 0;
    const header = comp.querySelector('.cart-drawer__header');
    const top = (html) => (header ? header.insertAdjacentHTML('afterend', html) : (comp.querySelector('.cart-items__wrapper') || comp.firstElementChild)?.insertAdjacentHTML('beforebegin', html));

    // order at the top: timer, then offer (insert offer first so the timer ends up above it)
    place(comp, 'data-kk-offer', has && cfg.enabled === 'true' && threshold ? offerHTML(cart.items_subtotal_price) : '', top);
    const beforeOffer = (html) => { const o = comp.querySelector('[data-kk-offer]'); o ? o.insertAdjacentHTML('beforebegin', html) : top(html); };
    place(comp, 'data-kk-timer', has && cfg.timer === 'true' ? timerHTML() : '', beforeOffer);

    // suggestions after the items
    const wrap = comp.querySelector('.cart-items__wrapper');
    place(comp, 'data-kk-upsell', has && wrap ? upsellHTML() : '', (html) => wrap.insertAdjacentHTML('afterend', html));

    // savings + trust in the summary
    const ctas = comp.querySelector('.cart__ctas');
    const saved = cart.total_discount || 0;
    place(comp, 'data-kk-saved', has && saved > 0 && ctas ? `<p class="kk-cart-saved" data-kk-saved>🎉 You're saving <strong>${money(saved)}</strong> on this order</p>` : '', (html) => ctas.insertAdjacentHTML('beforebegin', html));
    place(comp, 'data-kk-cart-trust', has && ctas ? trustHTML() : '', (html) => ctas.insertAdjacentHTML('afterend', html));
  });
}

async function loadUpsell() {
  if (!cfg.upsellHandle) return;
  try {
    const r = await fetch(`${root}collections/${encodeURIComponent(cfg.upsellHandle)}/products.json?limit=12`, { headers: { Accept: 'application/json' } });
    upsell = r.ok ? (await r.json()).products : [];
  } catch { upsell = []; }
  render();
}

/* one-tap add from the suggestions (same event Horizon's own forms send) */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-kk-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = 'Adding…';
  const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId);
  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.kkUpsellAdd), quantity: 1 }], ...(sections.length ? { sections: sections.join(',') } : {}) }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'Could not add');
    const fresh = await fetch(`${root}cart.js`).then((r) => r.json());
    const ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: fresh, sourceId: 'kk-upsell', data: { source: 'kk-upsell', itemCount: fresh.item_count, sections: data.sections } };
    document.dispatchEvent(ev);
  } catch {
    btn.disabled = false;
    btn.textContent = '+ Add';
  }
});

let queued = false;
const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; render(); }); };
const OURS = '[data-kk-offer], [data-kk-timer], [data-kk-upsell], [data-kk-saved], [data-kk-cart-trust]';
new MutationObserver((list) => {
  if (list.some((m) => [...m.addedNodes, ...m.removedNodes].some((n) => n.nodeType === 1 && !n.matches?.(OURS) && !n.closest?.(OURS)))) schedule();
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('cart:update', (e) => {
  const res = e.detail?.resource;
  if (res && typeof res.items_subtotal_price === 'number' && Array.isArray(res.items)) { cart = res; render(); }
  else loadCart();
});
loadCart();
loadUpsell();
